import { useEffect, useState } from "react";
import { X } from "lucide-react";
import { usePlayer } from "../context/PlayerContext";
import { followOnSpotify } from "../lib/spotify";
import { api } from "../lib/api";
import { SpotifyIcon } from "./icons/BrandIcons";

const DISMISS_KEY = "dc_sticky_follow_dismissed";

// Mobile-only sticky follow CTA. Hidden whenever the persistent player is
// active (a track is loaded) so it never overlaps playback controls, and
// hidden for the rest of the session once dismissed.
export default function MobileStickyFollow() {
  const { currentRelease } = usePlayer();
  const [spotifyArtistUrl, setSpotifyArtistUrl] = useState(null);
  const [dismissed, setDismissed] = useState(() => sessionStorage.getItem(DISMISS_KEY) === "1");

  useEffect(() => {
    api.get("/settings").then((r) => setSpotifyArtistUrl(r.data?.streaming?.spotify)).catch(() => {});
  }, []);

  if (dismissed || currentRelease || !spotifyArtistUrl) return null;

  const dismiss = () => {
    sessionStorage.setItem(DISMISS_KEY, "1");
    setDismissed(true);
  };

  return (
    <div data-testid="mobile-sticky-follow" className="fixed inset-x-3 bottom-3 z-40 sm:hidden">
      <div className="glass flex items-center gap-2 rounded-2xl border border-gold/20 p-2.5">
        <button
          data-testid="sticky-follow-button"
          onClick={() => followOnSpotify(spotifyArtistUrl)}
          className="flex-1 rounded-full bg-gold px-4 py-2.5 text-xs font-bold uppercase tracking-wide text-black transition-transform active:scale-95"
        >
          <span className="inline-flex items-center justify-center gap-1.5"><SpotifyIcon size={15} /> Follow DJ Código on Spotify</span>
        </button>
        <button
          data-testid="sticky-follow-dismiss"
          aria-label="Dismiss"
          onClick={dismiss}
          className="shrink-0 rounded-full p-2 text-white/50 transition-colors hover:text-white"
        >
          <X size={16} />
        </button>
      </div>
    </div>
  );
}
